export const listArrayItems = (arr) => {
    const arrCopy = [...arr];
    const last = arrCopy.splice(-1);
    return [arrCopy.join(', '), last[0]].filter(Boolean).join(' or ');
};
export default listArrayItems;
